import OverviewSummaryTable, {
	CustomDataTables
} from "@sabyr-dev/mist_core/lib/overviewsummary";
import { Product } from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyAttemptTableRecord } from "../model/datasource";

interface AcademyDataTableRows {
	add(rows: any[][]): void;
}

interface AcademyDataTableColumns {
	adjust(): AcademyDataTables;
}

export interface AcademyDataTables extends CustomDataTables {
	rows: AcademyDataTableRows;
	columns: AcademyDataTableColumns;

	table(): AcademyDataTables;

	header(): HTMLHeadElement;

	clear(): void;
}

export class AcademyOverviewSummaryTable extends OverviewSummaryTable<Product> {
	getTable(element: HTMLElement): AcademyDataTables {
		return this.jQuery(element).DataTable() as unknown as AcademyDataTables;
	}

	populate(table: AcademyDataTables, rows: AcademyAttemptTableRecord[]): void {
		table.clear();
		table.rows.add(rows.map(row => [
			row.id.toString(),
			row.complete.toString(),
			row.date.toISOString(),
			row.test,
			row.time.toString(),
			row.correct !== undefined ? row.correct.toString() : '',
			row.incorrect !== undefined ? row.incorrect.toString() : '',
			row.unanswered.toString(),
			row.total.toString(),
			row.percent ? `${Math.round(row.percent * 10000) / 100}%` : '',
			row.timeFormatted,
			row.first ?? ''
		]));
		const header = table.table().header();
		table.columns.adjust().draw();
		const filters = header.querySelector('tr.practice-filter');
		filters.remove();
		this.addFilterRow(table);
	}

	table(element: HTMLElement, product: Product): any {
		return this.jQuery(element).DataTable({
			dom: "<'row'<'col-sm-12 col-md-6 filter-toggle'><'col-sm-12 col-md-6 d-flex flex-row justify-content-end'l>>" +
				"<'row'<'col-sm-12'tr>>" +
				"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
			responsive: true,
			order: [[2, 'desc']],
			columns: [
				{ visible: false, type: 'num' },
				{
					render: (data, type, row, meta) => {
						if (type === 'display') {
							const complete = row[1] === 'true';
							const first = row[11];
							// const first = (this.jQuery(element).DataTable()
							// 	.cell({row: meta.row, column: meta.col})
							// 	.node() as HTMLElement)
							// 	.dataset.first;
							const content = `<div class="d-flex flex-row justify-content-center">
								<div style="width: 4.5em;">
									<input type="checkbox"
										${data === 'true' ? 'checked' : ''}
										onclick="return false;"
										style="filter: hue-rotate(270deg);"
									/>
									<a class="small ml-1" href="${[
								'/practicequestion',
								(complete ? 'result' : 'test'),
								this.productIdSerializer.toString(product),
								row[0]
							].join('/') + (first && !complete ? `#${first}` : '')}">
										<u>${(row[1] === 'true' ? 'Review' : 'Resume')}</u>
									</a>
								</div>
							</div>`;
							return content;
						}
						return data;
					}
				},
				{
					type: 'date', render: (data, type, row, meta) => {
						if (type === 'display') {
							return new Date(data).toLocaleString();
						}
						return data;
					}
				},
				{ type: 'html' },
				{
					type: 'num', render: (data, type, row, meta) => {
						if (type === 'display') {
							return row[10];
							// return (this.jQuery(element).DataTable()
							// 	.cell({row: meta.row, column: meta.col})
							// 	.node() as HTMLElement)
							// 	.dataset.formatted;
						}
						return data;
					}
				},
				{ type: 'num' },
				{ type: 'num' },
				{ type: 'num' },
				{ type: 'num' },
				{ type: 'num', render: (d) => d },
				{ type: 'string' },
				{ type: 'string' },
			]
		});
	}
}
